<template>
  <div>
    <header :class="['navbar', 'navbar-solid']">
      <div class="container">
        <div class="home hidden-sm-and-down">
          <a href="/">
            <img
              src="../assets/img_spin/logo.png"
              alt="Logo"
              style="height: 3.5vw; margin-top: 0.5vw"
            />
          </a>
        </div>
        <div class="menus hidden-sm-and-down">
          <el-menu
            default-active="1"
            class="el-menu-demo"
            mode="horizontal"
            :router="true"
            text-color="#e5ca8a"
            background-color="rgba(6,6,30,0)"
            active-text-color="#cba24c"
          >
            <el-menu-item index="/"
              ><span class="nav-span">{{ $t("nav.home") }}</span></el-menu-item
            >
            <el-menu-item index="/game"
              ><span class="nav-span">{{ $t("nav.game") }}</span></el-menu-item
            >
<!--            <el-menu-item index="/associates"-->
<!--              ><span class="nav-span">ASSOCIATES</span></el-menu-item-->
<!--            >-->
            <el-menu-item index="/join_social" v-show="$i18n.locale === 'en'"
              ><span class="nav-span">{{
                $t("nav.joinus")
              }}</span></el-menu-item
            >
            <el-menu-item index="/about"
              ><span class="nav-span">{{
                $t("nav.aboutus")
              }}</span></el-menu-item
            >
            <el-menu-item index="/privacy" v-show="$i18n.locale === 'en'"
              ><span class="nav-span">{{
                $t("nav.privacy")
              }}</span></el-menu-item
            >
            <el-menu-item index="/terms" v-show="$i18n.locale === 'en'"
              ><span class="nav-span">{{ $t("nav.terms") }}</span></el-menu-item
            >
            <el-menu-item index="/cookie_notice" v-show="$i18n.locale === 'en'"
              ><span class="nav-span">{{ $t("nav.cookie_notice") }}</span></el-menu-item>
            <el-submenu index="/data_delete">
              <template slot="title">
                <span class="nav-span special">Game Service</span>
              </template>
              <el-menu-item index="/data_delete"
                ><span class="nav-span">Data Deletion</span></el-menu-item
              >
              <el-menu-item index="/ethics"
              ><span class="nav-span">Code of Ethics</span></el-menu-item
              >
            </el-submenu>
          </el-menu>
        </div>
      </div>
    </header>
    <div class="header_mobile hidden-md-and-up" >
      <div class="home hidden-md-and-up">
        <a href="/">
          <img src="../assets/img_spin/logo.png" alt="Logo" />
        </a>
      </div>
      <div class="menus hidden-md-and-up">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          :router="true"
          text-color="#e5ca8a"
          background-color="rgba(6,6,30,0)"
          active-text-color="#cba24c"
        >
          <el-menu-item index="/"
            ><span class="nav-span">{{ $t("nav.home") }}</span></el-menu-item
          >
          <el-menu-item index="/game"
            ><span class="nav-span">{{ $t("nav.game") }}</span></el-menu-item
          >
<!--          <el-menu-item index="/associates"-->
<!--            ><span class="nav-span">ASSOCIATES</span></el-menu-item-->
<!--          >-->
          <el-menu-item index="/join_social" v-show="$i18n.locale === 'en'"
            ><span class="nav-span">{{ $t("nav.joinus") }}</span></el-menu-item
          >
          <el-menu-item index="/about"
            ><span class="nav-span">{{ $t("nav.aboutus") }}</span></el-menu-item
          >
          <el-menu-item index="/privacy" v-show="$i18n.locale === 'en'"
            ><span class="nav-span">{{ $t("nav.privacy") }}</span></el-menu-item
          >
          <el-menu-item index="/terms" v-show="$i18n.locale === 'en'"
            ><span class="nav-span">{{ $t("nav.terms") }}</span></el-menu-item
          >
          <el-menu-item index="/cookie_notice" v-show="$i18n.locale === 'en'"
            ><span class="nav-span">{{ $t("nav.cookie_notice") }}</span></el-menu-item>
          <el-submenu index="/data_delete">
            <template slot="title">
              <span class="nav-span special">Game Service</span>
            </template>
            <el-menu-item index="/data_delete"
              ><span class="nav-span">Data Deletion</span></el-menu-item
            >
            <el-menu-item index="/ethics"
            ><span class="nav-span">Code of Ethics</span></el-menu-item
            >
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["isHome"], // 如果是主页的navbar，则添加透明滚动渐变效果
  data() {
    return {
      scrolled: false, // 是否有滚动
      language: "zh",
      activeIndex2: "1",
    };
  },
  computed: {
    activeIndex() {
      return `/${this.$route.path.split("/")[1]}` || "/";
    },
    isBole() {
      return /bole|localhost/.test(window.location.hostname);
    },
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 0; // 滚动事件的回调
    },
    handleCommand(command) {
      // 小屏状态时的下来菜单点击回调
      this.$router.push(command);
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll); // 监听滚动事件
  },
};
</script>

<style lang="less" scoped>
@import "element-ui/lib/theme-chalk/display.css";
@import url("../assets/style/colors.less");
// 使得导航栏字体随着页面大小同步变化

.el-menu .el-menu-item, .nav-span {
  font-size: 1vw;
}

//.nav-span {
//  font-size: 1vw;
//}
//修复在放大到175%的时候导航栏消失的bug，原因时元素浮动 放大后会被挤到下面
.container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.special {
  vertical-align: top;
  @media screen and (max-width: 992px) {
    margin-right: 5px;

      font-size: 1.3vw;
      font-weight: 700;

  }
}

// 菜单栏

.navbar {
  background-color: @lanmu;
  .el-dropdown {
    float: right;
    color: white;
    font-size: 24px;
    font-weight: 700;
    padding-top: 10px;
    user-select: none;
    cursor: pointer;
  }
}

header {
  height: 4.5vw;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  line-height: 60px;
  z-index: 1000;

  //.home {
  //  float: left;
  //}

  .menus {
    //float: right;
    height: 100%;
    .el-menu {
      margin-right: 1vw;
    }
    .el-menu-item {
      width: 9.5vw;
      padding: 0 2px;
    }
    .el-submenu {
      width: 11vw;
    }
  }
  .lang {
    position: absolute;
    right: 0;
    top: 0;
    .el-menu {
      margin-right: 0vw;
    }
    .el-menu-item {
      width: 10vw;
      padding: 0 2px;
    }
    .el-submenu {
      width: 11vw;
    }
  }
}
.header_mobile {
  background-color: @lanmu_no;
  height: 17vw;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  .home {
    text-align: left;
    margin-left: 10vw;
    img {
      margin-top: 0.5vw;
      height: 7.5vw;
    }
  }
  .menus {
    .el-menu {
      width: 90%;
      margin: 0 auto;
      display: flex;
      overflow-x: hidden;
    }
    .el-menu-item {
      width: 24vw;
      height: 8vw;
      margin-right: 20px;
      @media screen and (max-width: 992px) {
        margin-right: 5px;
        .nav-span {
          font-size: 1.3vw;
          font-weight: 700;
        }
      }
    }
    .el-submenu {
      width: 22vw;
      height: 8vw;
      margin-right: 25px;
    }
  }

  .el-menu,
  .el-submenu__title,
  .el-menu-item {
    padding: 0 0;
  }
  .lang {
    position: absolute;
    right: 0;
    top: 1vw;
    .el-menu {
      margin-right: 0vw;
    }
    .el-menu-item {
      width: 22vw;
      height: 8vw;
    }
    .el-submenu {
      width: 22vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue